export default __webpack_public_path__ + "static/media/CorvoOutskirts.927494d3.jpg";